import { AudiencesState } from './types';
import { SortTypes, SortDirection } from '@/types/all-profiles.types';

export const initialState: AudiencesState = {
  loadingPasscodeList: false,
  passcodeLists: [],
  loadingPasscodeLists: false,
  passcodeListMembers: [],
  loadingPasscodeListMembers: false,
  loadingPasscodeListMembersListIds: [],
  showAddPasscodeListModal: false,
  paidLists: {},
  globalCurrencies: null,
  loadingPaidListMembers: false,
  paidListMembers: null,
  passcodeListMemberCount: 0,
  allProfiles: {
    loadingBase: false,
    loadingWatchtime: false,
    loadingStarScore: false,
    loadingTotal: false,
    users: [],
    page: 1,
    total: 0,
    search: '',
    sort: SortTypes.name,
    sortDirection: SortDirection.up,
    pageSize: '10',
  },
  allAttendees: {
    loading: false,
    users: [],
    total: 0,
    page: 1,
    pageSize: '25',
    search: '',
    sort: '',
    sortDirection: 'asc',
    fields: {},
  },
  listAttendees: {
    loading: false,
    users: [],
    total: 0,
    page: 1,
    pageSize: '25',
    search: '',
    sort: '',
    sortDirection: 'asc',
    fields: {},
  },
  audienceMembers: {
    source: null,
    requestId: null,
    loading: false,
    users: [],
    total: 0,
    page: 1,
    pageSize: '25',
    search: '',
    registrationStatus: 'all',
    sort: '',
    sortDirection: 'asc',
  },
};
